export const AppConstant = {
    accountBasicData: 'accountBasicData',
    amountMask: '#Monto#',
    creditLineFNB: 'creditLineFNB',
    false: 'false',
    FNB: 'FNB',
    maxLevelPopUp: 3,
    orderPopupFNB: 'orderPopupFNB',
    orderPopupHome: 'orderPopupHome',
    paragraphSeparator: '</p>',
    statusPopupFNB: 'statusPopupFNB',
    statusPopupHome: 'statusPopupHome',
    userMask: '#Usuario#',       
    rangoDiasEnvio:3,
    PlazoAnnios:5,
    documentTypeDNI: 'PE2',
    messageCannotBuy: 'Estimado cliente, el número de documento que ingresa no es válido por lo que lo invitamos a llamar nuestro call center al 01 614 9000 opción 3  para que pueda finalizar la solicitud del financiamiento. Gracias.'
}
